import React, { useEffect, useCallback, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';


type GlobalMenuProps = {
    className?: string;
    children?: React.ReactNode
}

const GlobalMenu: React.FC<GlobalMenuProps> = props => {
    const ref = useRef(null);
    const year:number = new Date().getFullYear();

    const handleToggleMenus = () => {
        document.querySelector('body')?.toggleAttribute("data-menu-expand");
    }

    const handleCloseMenus = () => {
        document.querySelector('body')?.removeAttribute("data-menu-expand");
    }

	const clickListener = useCallback((e: MouseEvent) => {
		if (!(ref.current! as any).contains(e.target)) {
            handleCloseMenus();
		} else {
			const target:any = e.target;
		}
	}, []);

	useEffect(() => {
		document.addEventListener('click', clickListener);

		return () => {
			document.removeEventListener('click', clickListener);
		};
	});
    
    return(
        <div className="layout-header">
            <button type="button" className="toggle-menus" ref={ref} onClick={handleToggleMenus}>
                <div className="box"><span className="inner">메뉴 열기/닫기</span></div>
            </button>

            <h1 className="title">
                <Link to="/"><span className="logo">ONE O ONE</span><span className="companies">architects | factory | plus</span></Link>
            </h1>

            <nav className="menus">
                <ul className="list-menus">
                    <li>
                        <NavLink to="/news/" activeClassName="selected" onClick={handleCloseMenus}>news</NavLink>
                        <ul className="list-sub-menus">
                            {[...Array(year-2019+1)].map((_: number, _index: number) => {
                                const _year = year - _index;
                                return(
                                    <li><NavLink exact to={`/news/${_year}?lastIndex=0&openIndex=0`} activeClassName="selected" onClick={handleCloseMenus}>{_year}</NavLink></li>
                                )
                            })}
                        </ul>
                    </li>
                    <li>
                        <NavLink to="/projects" activeClassName="selected" onClick={handleCloseMenus}>projects</NavLink>
                        <ul className="list-sub-menus">
                            <li><NavLink exact to="/projects/architecture" activeClassName="selected" onClick={handleCloseMenus}>architecture</NavLink></li>
                            <li><NavLink exact to="/projects/graphics" activeClassName="selected" onClick={handleCloseMenus}>graphic</NavLink></li>
                            <li><NavLink exact to="/projects/all" activeClassName="selected" onClick={handleCloseMenus}>all</NavLink></li>
                        </ul>
                    </li>
                    <li>
                        <NavLink to="/about" activeClassName="selected" onClick={handleCloseMenus}>about</NavLink>
                        <ul className="list-sub-menus">
                            <li><NavLink exact to="/about/introduction" activeClassName="selected" onClick={handleCloseMenus}>introduction</NavLink></li>
                            <li><NavLink exact to="/about/people" activeClassName="selected" onClick={handleCloseMenus}>people</NavLink></li>
                            <li><NavLink exact to="/about/essay&drawing" activeClassName="selected" onClick={handleCloseMenus}>essay&drawing</NavLink></li>
                        </ul>
                    </li>
                    <li>
                        <NavLink to="/recruit" activeClassName="selected" onClick={handleCloseMenus}>recruitment</NavLink>
                    </li>
                </ul>

                <ul className="list-external">
                    <li><a href="https://www.instagram.com/oneoone.archive/" target="_blank">instagram</a></li>
                    <li><a href="https://twitter.com/oneoone_archive/" target="_blank">twitter</a></li>
                </ul>
            </nav>

        </div>
    )
}

export default GlobalMenu;
